import { Libraries } from '@react-google-maps/api';

import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const API = {
    URL_RETAILS_MAP_SEARCH: `/rest/v2/{siteName}/{segmentSlug}/retails-map/search`,
};

if (checkShouldUseMocks()) {
    API.URL_RETAILS_MAP_SEARCH = '/api/retails/retails-list';
}

export const RETAILS_MAP_QUERY_KEY = {
    SEARCH: 'retails-map-search',
};

export const RETAILS_MARKERS = {
    icon: '../../../images/map-icon.svg',
    size: {
        small: {
            height: 43,
            width: 27,
        },
        big: {
            height: 54,
            width: 40,
        },
    },
};

export const GOOGLE_MAPS = {
    version: '3.exp',
    language: 'lt',
    libraries: ['geometry', 'drawing', 'places'] as Libraries,
    dirUrl: 'https://www.google.lt/maps/dir/?api=1&destination=',
    dirUrlApple: 'maps://www.google.lt/maps/dir/?api=1&destination=',
    initialBounds: {
        south: 54.24249417920566,
        west: 21.656740623474136,
        north: 56.276658141154314,
        east: 26.128176170349136,
    },
    lat: 55.169,
    lng: 23.881,
    zoom: {
        world: 5,
        map: 7,
        city: 12,
        salon: 16,
    },
    nonce: 'retails-google-maps',
};
